import Constants from '../constants'

const INITITAL_STATE = {
    timelineConfig: {
        // enabled default is false because timeline is an add-on
        // and we have to wait until store is updated with server data
        disabled: false,
        mode: 'temporal'
    },
    // userTimelineVisible default is false because timeline is an add-on
    // and we have to wait until store is updated with server data
    userTimelineVisible: false,
    error: null
}

const timeline = (state = INITITAL_STATE, action) => {
    switch (action.type) {

    case Constants.APPLY_TIMELINE_CONFIG:

        return ({
            ...state,
            timelineConfig: action.timelineConfig,
            error: null
        })
        break

    case Constants.APPLY_USER_TIMELINE_CONFIG:

        return ({
            ...state,
            userTimelineVisible: action.userTimelineVisible,
            error: null
        })
        break

    case Constants.SET_ERROR:

        return ({
            ...state,
            error: action.error
        })
        break

    default:
        return state
    }
}

export default timeline
